import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

const Info: React.FC = () => {
  const { i18n, t } = useTranslation("info");
  const [searchParams] = useSearchParams();
  const scrollTo = searchParams.get("scrollTo");

  useEffect(() => {
    const element = document.getElementById("info-" + scrollTo);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  }, [scrollTo]);

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Col>
            <div id={"info-presentation"} />
            <h2 className="display-3 my-5 text-center">{t("presentationTitle")}</h2>
            <div className="embed-responsive embed-responsive-16by9 overflow-hidden" style={{ maxHeight: "70vh" }}>
              {i18n.language === "es" ? (
                <iframe
                  className="embed-responsive-item m--1 bg-white"
                  loading="lazy"
                  allowFullScreen={true}
                  allow="fullscreen"
                  src="https://www.canva.com/design/DAHWNCkGArk/Gprt0dB9IthoxF956WWeOQ/view?embed"
                />
              ) : (
                <iframe
                  className="embed-responsive-item m--1 bg-white"
                  loading="lazy"
                  allowFullScreen={true}
                  allow="fullscreen"
                  src="https://www.canva.com/design/DAHWNPvaglU/DbOIZkEF48It366YinwOYA/view?embed"
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Info;
